"use strict";

var _interopRequireDefault = require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _pbw = require("@/api/pbw/pbw");
var _purchase = require("@/api/purchase");
var _customField = require("@/api/customField");
var _index = require("@/api/transport/index");
var data = {
  namespaced: true,
  state: {
    userList: [],
    supplierList: [],
    supplierTypeList: [],
    transportList: []
  },
  mutations: {
    setUserList: function setUserList(state, value) {
      state.userList = value;
    },
    setSupplierList: function setSupplierList(state, value) {
      state.supplierList = value;
    },
    setSupplierTypeList: function setSupplierTypeList(state, value) {
      state.supplierTypeList = value;
    },
    setTransportList: function setTransportList(state, value) {
      state.transportList = value;
    }
  },
  actions: {
    // 获取用户列表
    getUserList: function () {
      var _getUserList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
        var commit, _yield$User, data, data2;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.next = 3;
              return (0, _pbw.User)({
                limit: 1,
                status: 1
              });
            case 3:
              _yield$User = _context.sent;
              data = _yield$User.data;
              if (!(data.pageArr.count > 0)) {
                _context.next = 12;
                break;
              }
              _context.next = 8;
              return (0, _pbw.User)({
                limit: data.pageArr.count,
                status: 1
              });
            case 8:
              data2 = _context.sent;
              commit('setUserList', data2.data.list);
              _context.next = 13;
              break;
            case 12:
              commit('setUserList', []);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getUserList(_x) {
        return _getUserList.apply(this, arguments);
      }
      return getUserList;
    }(),
    // 获取供应商类型
    getSupplierTypeList: function () {
      var _getSupplierTypeList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(_ref2) {
        var commit, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              _context2.next = 3;
              return (0, _customField.getSelectList)({
                limit: 1,
                type: 5
              });
            case 3:
              data = _context2.sent;
              console.log("%c Line:39 🍫 data", "color:#33a5ff", data);
              if (data.data) {
                commit('setSupplierTypeList', data.data[0].value);
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getSupplierTypeList(_x2) {
        return _getSupplierTypeList.apply(this, arguments);
      }
      return getSupplierTypeList;
    }(),
    // 获取供应商列表
    getSupplierList: function () {
      var _getSupplierList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(_ref3, data) {
        var commit, data2;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              console.log("%c Line:31 🌮 getSupplierList", "color:#93c0a4", data);
              _context3.next = 4;
              return (0, _purchase.getSupplierList)((0, _objectSpread2.default)({
                limit: 10
              }, data ? data : {}));
            case 4:
              data2 = _context3.sent;
              commit('setSupplierList', data2.data.list);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getSupplierList(_x3, _x4) {
        return _getSupplierList2.apply(this, arguments);
      }
      return getSupplierList;
    }(),
    // 获取物流公司列表
    getTransportList: function () {
      var _getTransportList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(_ref4, data) {
        var commit, data2;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;
              console.log("%c Line:31 🌮 getTransportList", "color:#93c0a4", data);
              _context4.next = 4;
              return (0, _index.getTransport)((0, _objectSpread2.default)({
                limit: 10
              }, data ? data : {}));
            case 4:
              data2 = _context4.sent;
              commit('setTransportList', data2.data.list);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function getTransportList(_x5, _x6) {
        return _getTransportList.apply(this, arguments);
      }
      return getTransportList;
    }()
  }
};
var _default = data;
exports.default = _default;